export default function MuiFormControl(theme: any) {
  return {
    MuiFormControl: {
      variants: [],
      styleOverrides: {
        root: {
          color: theme.palette.grey[0],
          "& .MuiFormControlLabel-root": {
            marginLeft: 0,
          },
        },
      },
    },
  };
}
